import { IContextRequest, IContextResponse } from './GameActions';

export enum ContextType {
    /**
     * The application context.
     */
    DEFAULT = 'default',

    /**
     * Unlock a gate by inviting a friend.
     */
    ADD_GATE_FRIEND = 'addGateFriend',

    /**
     * IAP context
     */
    PURCHASE_PRODUCT = 'purchaseProduct',

    /**
     * Invite a friend (shareAsync).
     */
    INVITE_FRIEND = 'inviteFriend',

    /**
     * Challenge a friend (playWithFriends).
     */
    CHALLENGE_FRIEND = 'challengeFriend',

    /**
     * Share beat highscore level with a friend.
     */
    SHARE_BEAT_HIGHSCORE_LEVEL = 'shareBeatHighscoreLevel',

    /**
     * Challenge/Send Gift to friend in social hub.
     */
    SEND_GIFT = 'sendGift',

    /**
     * Send a life to a friend.
     */
    SEND_LIFE = 'sendLife',

    /**
     * Request a life from a friend.
     */
    REQUEST_LIFE = 'requestLife',
    /**
     * Share a bot message with their friends.
     */
    SHARE_3_STAR_REWARD = 'share3StarReward',

    /**
     * Share a postcard.
     */
    SHARE_POSTCARD = 'sharePostcard',

    /**
     * Share a screenshot of the game
     * data.message: The Message sent to the friend
     * data.payloadData: Payload data sent with it (for tracking)
     */
    SHARE_SCREENSHOT = 'shareScreenshot',

    /**
     * Watch an advertisement.
     */
    DISPLAY_ADVERTISEMENT = 'displayAdvertisement',

    /**
     * Request that the player subscribe the bot associated to the game.
     */
    SUBSCRIBE_BOT_OPT_IN = 'subscribeBotOptIn',

    /**
     * Prompt user to add home-screen shortcut.
     */
    CREATE_SHORTCUT = 'addHomeScreenShortcut',

    /**
     * Prompt the user to switch into the specified game.
     */
    SWITCH_GAME = 'switchGame',

    /**
     * Request Help from friend.
     */
    REQUEST_HELP = 'requestHelp',
}

export interface IContext {
    /**
     * The currently active context.
     */
    current: ContextType;

    /**
     * The payload sent to the new context.
     */
    request?: IContextRequest;

    /**
     * The response from the most recent context.
     */
    response?: IContextResponse;

    /**
     * Whether or not audio is enabled in the current context.
     */
    audioEnabled: boolean;
}

export const initialContext: IContext = {
    current: ContextType.DEFAULT,
    audioEnabled: true,
};
